import {
  NavMenuItemInterface,
  IntroductionInterface,
  SkillInterface,
  ProjectsInterface,
} from "../interfaces/interfaces";
import html from "../../assets/images/html.png";
import css from "../../assets/images/css.png";
import javascript from "../../assets/images/javascript.png";
import react from "../../assets/images/react.png";
import notesland from "../../assets/images/notesland.png";
import redux from "../../assets/images/redux.png";
import cpp from "../../assets/images/cpp.png";
import git from "../../assets/images/git.png";
import mu5 from "../../assets/images/mu5.png";
import node from "../../assets/images/node.png";
import sass from "../../assets/images/sass.png";
import typescript from "../../assets/images/typescript.png";
import myportfolio from "../../assets/images/myPortfolio.png";
import expensetracker from "../../assets/images/expense tracker.png";
import agecalculator from "../../assets/images/age calculator.png";
import sql from "../../assets/images/sql.png";
import mongoDB from "../../assets/images/mongodb.jpeg";
import express from "../../assets/images/express.png";
import php from "../../assets/images/php.png";
import restapi from "../../assets/images/restapi.png";
import angular from "../../assets/images/angular.png";
import nextjs from "../../assets/images/nextjs.png";
import convocationImg from "../../assets/images/convocation.jpg";
import ecommerceWebsite from "../../assets/images/ecommercewebsite.png";
import eventOrganizer from "../../assets/images/eventOrganizer.png";
import weatherApp from "../../assets/images/weather.png";
import foodRecipe from "../../assets/images/foodrecipereact.png";
import portfoliowebsite from "../../assets/images/portfoliowebsite.png";
import notfound from "../../assets/images/notfound.jpeg";
import covid19rc from "../../assets/images/covid19rc.png";
import loginauthrc from "../../assets/images/loginauthrc.png";
import notesapprc from "../../assets/images/notesapprc.png";
import instagramrc from "../../assets/images/instagramrc.png";
import foodreciperc from "../../assets/images/foodreciperc.png";
import twitterrc from "../../assets/images/twitterrc.png";
import drumsjs from "../../assets/images/drumsjs.png";
import authpagejs from "../../assets/images/authpagejs.png";
import bankingjs from "../../assets/images/bankingjs.png";
import dicerolljs from "../../assets/images/dicerolljs.png";
import fortniteapijs from "../../assets/images/forniteapijs.png";
import googleclonejs from "../../assets/images/googleclonejs.png";
import guessinggamejs from "../../assets/images/guessinggamejs.png";
import notesjs from "../../assets/images/notesjs.png";
import piggamejs from "../../assets/images/piggamejs.png";
import simonjs from "../../assets/images/simonjs.png";
import todolistjs from "../../assets/images/todolistjs.png";
import workoutjs from "../../assets/images/workoutjs.png";
import angulardashboard from "../../assets/images/angulardashboard.png";
import prixite from "../../assets/images/prixite.png";
import bloodbank from "../../assets/images/bloodbank.png";
import github from "../../assets/images/github.webp";
import instagram from "../../assets/images/instagram.jpeg";
import facebook from "../../assets/images/facebook.webp";
import linkdein from "../../assets/images/linkdein.png";
import patreon from "../../assets/images/patreon.png";
import buymeacoffee from "../../assets/images/buymeacoffee.png";
import youtube from "../../assets/images/youtube.png";
import gmail from "../../assets/images/gmail.png";

//  Nav Menu Items
export const Nav_Menu: NavMenuItemInterface[] = [
  { text: "Home", path: "/" },
  { text: "Projects", path: "/projects" },
  { text: "APIs", path: "/apis" },
  { text: "About", path: "/about" },
];

//  Introduction Container
export const introduction: IntroductionInterface = {
  name: "Asfand Jameel",
  designation: "Software Engineer 👨🏻‍💻",
  description: `I'm a professional Full-Stack Web App Developer based in Pakistan.`,
};

//  Skills
export const skills: SkillInterface[] = [
  { image: html, text: "HTML", rating: 100 },
  { image: css, text: "CSS", rating: 90 },
  { image: javascript, text: "JavaScript", rating: 85 },
  { image: react, text: "React", rating: 90 },
  { image: cpp, text: "C++", rating: 70 },
  { image: git, text: "Git & Github", rating: 30 },
  { image: mu5, text: "Material UI", rating: 95 },
  { image: node, text: "Node JS", rating: 30 },
  { image: typescript, text: "Typescript", rating: 20 },
];

//  Qualification Data
export const qualification = {
  title: `Bachelor's in Information Technology`,
  year: "2014-2018",
  cgpa: 3.1,
  image: convocationImg,
};

// Crypto Api Table Header Data
export const cryptoApiHeader: string[] = [
  "Name",
  "Symbol",
  "Price",
  "Rank",
  "High",
  "Low",
  "Last Update",
  "Cir. Supply",
  "Total Supply",
  "Ath",
  "Atl",
];

// Projects Tab Data
export const projectsTab: ProjectsInterface[] = [
  {
    tabImage: react,
    label: "React",
    projects: [
      {
        image: notesland,
        title: "Note Taking App",
        description:
          "Note taking app, in which user can login or register with email and add,delete or edit notes.",
        technologies: ["React | MUI | Firebase | Chart JS"],
      },
      {
        image: myportfolio,
        title: "Portfolio Website",
        description: "Portfilio Website is basically you are using right now.",
        technologies: ["React | Node | Express | MongoDB | Material UI"],
      },
      {
        image: weatherApp,
        title: "Weather App",
        description:
          "Weather App in which user can see weather details like temperature, humidity, pressure, visibility of any country or city by search. This project is using weather api from Rapid API service.",
        technologies: ["React | Rapid API"],
      },
      {
        image: expensetracker,
        title: "Expense Tracker App",
        description:
          "This is the Expense tracker App in which you can add your monthly expenses.",
        technologies: ["React | Javascript"],
      },
      {
        image: agecalculator,
        title: "Age Calculator",
        description:
          "This is the Age calculator in which you can find your age by using date of birth",
        technologies: ["React | Material UI"],
      },
    ],
  },

  {
    tabImage: javascript,
    label: "Javascript",
    projects: [
      {
        image: fortniteapijs,
        title: "Fortnite Api Project",
        description:
          "This project uses external fortnite api to render data in the UI as user need with CRUD Operations as well.",
        technologies: ["HTML | CSS | Javascript | Fortnite API"],
      },
      {
        image: notesjs,
        title: "Notes App",
        description:
          "This project is simple notes app with CRUD operations with beatifull UI.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: piggamejs,
        title: "Pig Game",
        description:
          "This project is a game in which two players can play and if one of the player get higher score using dice will be a winner.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: todolistjs,
        title: "Todo List",
        description:
          "This project is a Todo List App in which user can add todos, delete them, mark them as completed. If user mark todo as completed, so completed todo goes to completed section shown in the right side of the image.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: bankingjs,
        title: "Banking Web App",
        description:
          "This project is a banking web app in which user can login by pin code and make transactions wit other user. User can also see history of transactions with date user made. ",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: dicerolljs,
        title: "Dice Roll Game",
        description:
          "This project is a game like we roll the dice in Ludo. If dice number is greated than other user's dice, that user will be winner. If both the dices values are equal, game will be draw.",
        technologies: ["HTML | CSS | Javascript | Bootstrap"],
      },
      {
        image: drumsjs,
        title: "Drums",
        description:
          "This project is like user can play drums and make sound with it.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: googleclonejs,
        title: "Google Clone",
        description:
          "This project is a clone of Google with completed reponsiveness. Also dark mode implemented as well using local storage and switch button.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: authpagejs,
        title: "Auth Page",
        description:
          "In this project there are two two pages like sign in page and sign up page. User can switch between these pages.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: guessinggamejs,
        title: "Guessing Game",
        description:
          "In this project user have to guess the number which is given by app and if the number is correct, score will be incremented.",
        technologies: ["HTML | CSS | Javascript"],
      },
      {
        image: simonjs,
        title: "Simon Game",
        description:
          "In this project user have to remember the squence of blinking buttons and everytime the buttons blinks, user have to click on that button according to previous sequence. If sequence is not correct, game will be over.",
        technologies: ["HTML | CSS | Javascript"],
      },
    ],
  },

  {
    tabImage: cpp,
    label: "C++",
    projects: [
      {
        image: notfound,
        title: "Caculator App",
        description:
          "This app is a calculator with all mathematical operations like addition, subtraction, multiplication and division.",
        technologies: ["C++"],
      },
      {
        image: notfound,
        title: "Car Parking System",
        description:
          "In this project there is a car parking system. Car Ticket will be assigned if car is parked. Manager can see list of cars and if parking hall is full, no car will be parked then.",
        technologies: ["C++"],
      },
      {
        image: notfound,
        title: "Restaurant Order Management System",
        description:
          "In this project the manager of restaurant handles the orders of customers with menu items and delierved them with bill receipt.",
        technologies: ["C++"],
      },
      {
        image: notfound,
        title: "Tic Toe Game",
        description: "This project is a usual Tic Toe Game.",
        technologies: ["C++"],
      },
    ],
  },
];

// About Us Page Data
export const aboutUsPage = {
  aboutPortfolio: {
    title: "About Portfolio",
    header: "This portfolio website built with the following technologies:",
    tech: {
      frontEndTitle: "Front End",
      frontEnd: [
        {
          techName: "React",
        },
        {
          techName: "Typescript",
        },
        {
          techName: "Material UI",
        },
        {
          techName: "Crypto API",
        },
      ],
      backEndTitle: "Back End",
      backEnd: [
        {
          techName: "Node",
        },
        {
          techName: "Firebase",
        },
      ],
    },
  },
  aboutMe: {
    title: "About Me",
    experience: {
      heading: "Full-Stack Developer ",
      details: [
        {
          desc: "React JS / Next JS for Frontend Development.",
        },

        {
          desc: "CSS & HTML.",
        },
        {
          desc: "Hands-On Experience with JavaScript.",
        },

        {
          desc: "Firebase for Database.",
        },

        {
          desc: "Have some experience of Git & Github as well.",
        },
        {
          desc: "Also Worked with DevOp Tech (CI/CD Pipeline using Github Actions via automation).",
        },
        {
          desc: "Deployed on Netlify, Github Pages.",
        },
        {
          desc: "Hands-on Experience with React JS.",
        },
        {
          desc: "Capable of learning and working on any Programming Language / Framework.",
        },
      ],
    },
  },
};

// Contact Me Card Data
export const contactMeSection = {
  contact: [
    {
      image: linkdein,
      title: "Linkdein",
      detail: "https://linkedin.com/in/asfund-mirza-794363274",
    },
    {
      image: github,
      title: "Github",
      detail: "https://github.com/asfundmirza",
    },
    {
      image: facebook,
      title: "Facebook",
      detail: "https://www.facebook.com/asfund.mirza",
    },
    {
      image: instagram,
      title: "Instagram",
      detail: "https://www.instagram.com/asfandmirza",
    },

    {
      image: buymeacoffee,
      title: "Buy Me A Coffee",
      detail: "https://www.buymeacoffee.com/asfundmirz0",
    },

    {
      image: gmail,
      title: "Gmail",
      detail: "mailto:asfundmirzaj@gmail.com",
    },
  ],
};
